import EventBlockPreview from "./EventBlockPreview";

export default EventBlockPreview;